<template>
    <div class="create">
        <h2>致力于为用户创造高品质的<br/>移动互联网产品</h2>
        <div class="img-con">
            <div class="img-item bg-img1">
                <div class="con">
                    <img src="@/assets/imgs/16.png" />
                    <div class="name">高端APP开发</div>
                </div>
            </div>
            <div class="img-item bg-img2">
                <div class="con">
                    <img src="@/assets/imgs/18.png" />
                    <div class="name">⼩程序定制</div>
                </div>
            </div>
            <div class="img-item bg-img3">
                <div class="con">
                    <img src="@/assets/imgs/20.png" />
                    <div class="name">⽹页设计</div>
                </div>
            </div>
            <div class="img-item bg-img4">
                <div class="con">
                    <img src="@/assets/imgs/22.png" />
                    <div class="name">软件开发</div>
                </div>
            </div>
        </div>
        <div class="menu-con">
            <div class="menu-item">
                <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs5/Image%2023%402x.png" />
                <div class="title">范围管理</div>
            </div>
            <div class="menu-item">
                <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs5/Image%2024%402x.png" />
                <div class="title">需求管理</div>
            </div>
            <div class="menu-item">
                <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs5/Image%2025%402x.png" />
                <div class="title">沟通管理</div>
            </div>
            <div class="menu-item">
                <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs5/Image%2026%402x.png" />
                <div class="title">风险管理</div>
            </div>
            <div class="menu-item">
                <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs5/Image%2027%402x.png" />
                <div class="title">质量管理</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped lang="scss">
    .create{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 51px;
        box-sizing: border-box;
        h2{
            font-size: 34px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000B33;
            line-height: 51px;
            text-align: center;
        }
        .img-con{
            margin-top: 77px;
            display: flex;
            align-items: center;
            gap: 63px;
            .img-item{
                width: 237px;
                height: 237px;
                background-position: center;
                background-size: cover;
                background-repeat: no-repeat;
                display: flex;
                align-items: center;
                justify-content: center;
                .con{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap:10px;
                    img{
                        width: 40px;
                        height: 43px;
                    }
                    .name{
                        font-size: 15px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 21px;
                    }
                }
            }
            .bg-img1{
                background-image: url("https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs5/Image%2015%402x.png");
            }
            .bg-img2{
                background-image: url("https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs5/Image%2017%402x.png");
            }
            .bg-img3{
                background-image: url("https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs5/Image%2019%402x.png");
            }
            .bg-img4{
                background-image: url("https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs5/Image%2021%402x.png");
            }
        }
        .menu-con{
            margin-top: 78px;
            display: flex;
            align-items: center;
            gap:144px;
            .menu-item{
                display: flex;
                flex-direction: column;
                align-items: center;
                img{
                    width: 78px;
                    height: 78px;
                }
                .title{
                    font-size: 17px;
                    font-family: STSongti-SC-Regular, STSongti-SC;
                    font-weight: 400;
                    color: #212529;
                    line-height: 24px;
                    margin-top:10px;
                }
            }
        }
    }
</style>